const serialNumberFields = [
  {
    field: 'commands',
    title: 'Actions',
    cell: 'commands',
    sortable: false,
    locked: true,
    hidden: false,
    width: 100,
  },
  {
    field: 'status',
    title: 'Status',
    sortable: false,
    width: 200,
  },
  {
    field: 'location',
    title: 'Status',
    sortable: false,
    width: 200,
  },
  {
    field: 'serialNumber',
    title: 'Serial Number',
    sortable: false,
    width: 200,
  },
  {
    field: 'serialNumber2',
    title: 'Serial Number 2',
    sortable: false,
    width: 200,
  },
  {
    field: 'pono',
    title: 'PONo',
    sortable: false,
    width: 200,
  },
  {
    field: 'receivedDate',
    title: 'Received Date',
    sortable: false,
    width: 200,
  },
  {
    field: 'receivedByUserId',
    title: 'Received By',
    sortable: false,
    width: 200,
  },
  {
    field: 'sono',
    title: 'SONo',
    sortable: false,
    width: 200,
  },
  {
    field: 'invoiceNo',
    title: 'Invoice No',
    sortable: false,
    width: 200,
  },
  {
    field: 'enteredByUserId',
    title: 'Entered By',
    sortable: false,
    width: 200,
  },
  {
    field: 'comment',
    title: 'Comment',
    sortable: false,
    width: 200,
  },
];

export default serialNumberFields;
